"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shapesMiniMax = exports.sortShapes = exports.shapesFromGroups = void 0;
function shapesFromGroups({ list = [] }) {
    let shapes = [];
    for (const groups of list) {
        if (Array.isArray(groups)) {
            for (const group of groups) {
                if (group.shapes && Array.isArray(group.shapes)) {
                    for (const shape of group.shapes) {
                        if ((shape === null || shape === void 0 ? void 0 : shape.shapeType) === 'path' && shape.points && Array.isArray(shape.points)) {
                            shapes.push(Object.assign(Object.assign({}, shape), { points: shape.points.map((p) => {
                                    var _a, _b, _c, _d;
                                    return ({
                                        x: ((_a = p === null || p === void 0 ? void 0 : p.x) !== null && _a !== void 0 ? _a : 0) + ((_b = group === null || group === void 0 ? void 0 : group.x) !== null && _b !== void 0 ? _b : 0),
                                        y: ((_c = p === null || p === void 0 ? void 0 : p.y) !== null && _c !== void 0 ? _c : 0) + ((_d = group === null || group === void 0 ? void 0 : group.y) !== null && _d !== void 0 ? _d : 0),
                                    });
                                }) }));
                        }
                        else if ((shape === null || shape === void 0 ? void 0 : shape.x) !== undefined && (shape === null || shape === void 0 ? void 0 : shape.y) !== undefined) {
                            shapes.push(Object.assign(Object.assign({}, shape), { x: shape.x + group.x, y: shape.y + group.y }));
                        }
                    }
                }
            }
        }
    }
    return shapes;
}
exports.shapesFromGroups = shapesFromGroups;
function sortShapes({ shapes = [], isYFirst }) {
    return [...shapes].sort((a, b) => {
        if (isYFirst) {
            if (a.y > b.y)
                return 1;
            if (a.y < b.y)
                return -1;
            if (a.x > b.x)
                return 1;
            if (a.x < b.x)
                return -1;
            return 0;
        }
        if (a.x > b.x)
            return 1;
        if (a.x < b.x)
            return -1;
        if (a.y > b.y)
            return 1;
        if (a.y < b.y)
            return -1;
        return 0;
    });
}
exports.sortShapes = sortShapes;
function getShapeAtTopLeft(shapes = [], x, y) {
    return shapes.find((s) => s.x === x && s.y === y);
}
function getShapeAtTopRight(shapes = [], x, y) {
    return shapes.find((s) => s.x + s.w === x && s.y === y);
}
function getShapeAtBottomRight(shapes = [], x, y) {
    return shapes.find((s) => s.x + s.w === x && s.y + s.h === y);
}
function getShapeAtBottomLeft(shapes = [], x, y) {
    return shapes.find((s) => s.x === x && s.y + s.h === y);
}
function shapesMiniMax({ shapes = [], boundsMinX, boundsMaxX, boundsMinY, boundsMaxY }) {
    const minX = Math.min(...shapes.map((s) => s.x));
    const maxX = Math.max(...shapes.map((s) => s.x + s.w));
    const minY = Math.min(...shapes.map((s) => s.y));
    const maxY = Math.max(...shapes.map((s) => s.y + s.h));
    let perimeter = 0;
    let shape;
    let lastShape;
    let outOfBounds = false;
    if (boundsMinX !== undefined && boundsMaxX !== undefined && boundsMinY !== undefined && boundsMaxY !== undefined) {
        outOfBounds = minX < boundsMinX || maxX > boundsMaxX || minY < boundsMinY || maxY > boundsMaxY;
    }
    if (!outOfBounds) {
        // Across the top, left to right.
        shape = getShapeAtTopLeft(shapes, minX, minY);
        if (shape !== undefined) {
            lastShape = shape;
            perimeter += shape.w;
            do {
                const nextX = shape.x + shape.w;
                shape = getShapeAtTopLeft(shapes, nextX, shape.y);
                if (shape) {
                    lastShape = shape;
                    perimeter += shape.w;
                }
            } while (shape);
        }
        // Down the right.
        shape = lastShape !== null && lastShape !== void 0 ? lastShape : shape;
        if (shape !== undefined) {
            lastShape = shape;
            perimeter += shape.h;
            do {
                const nextX = shape.x + shape.w;
                const nextY = shape.y + shape.h;
                shape = getShapeAtTopRight(shapes, nextX, nextY);
                if (shape) {
                    perimeter += shape.h;
                    lastShape = shape;
                }
            } while (shape);
        }
        // Across the bottom, right to left.
        shape = lastShape !== null && lastShape !== void 0 ? lastShape : shape;
        if (shape !== undefined) {
            lastShape = shape;
            perimeter += shape.w;
            do {
                const nextX = shape.x;
                const nextY = shape.y + shape.h;
                shape = getShapeAtBottomRight(shapes, nextX, nextY);
                if (shape) {
                    perimeter += shape.w;
                    lastShape = shape;
                }
            } while (shape);
        }
        // Up the left.
        shape = lastShape !== null && lastShape !== void 0 ? lastShape : shape;
        if (shape !== undefined) {
            perimeter += shape.h;
            do {
                const nextX = shape.x;
                const nextY = shape.y;
                shape = getShapeAtBottomLeft(shapes, nextX, nextY);
                if (shape) {
                    perimeter += shape.h;
                }
            } while (shape);
        }
    }
    const xInside = (x, shapeToHit) => x > shapeToHit.x && x < shapeToHit.x + shapeToHit.w;
    const yInside = (y, shapeToHit) => y > shapeToHit.y && y < shapeToHit.y + shapeToHit.h;
    const doesPointHitShape = ({ x, y }, shapeToHit) => {
        return xInside(x, shapeToHit) && yInside(y, shapeToHit);
    };
    const doesShapeHitShape = ({ x, y, w, h }, shapeToHit) => {
        return doesPointHitShape({ x, y }, shapeToHit)
            || doesPointHitShape({ x: x + w, y }, shapeToHit)
            || doesPointHitShape({ x, y: y + h }, shapeToHit)
            || doesPointHitShape({ x: x + w, y: y + h }, shapeToHit)
            || doesPointHitShape({ x: x + w / 2, y }, shapeToHit)
            || doesPointHitShape({ x: x + w / 2, y: y + h }, shapeToHit)
            || doesPointHitShape({ x: x, y: y + h / 2 }, shapeToHit)
            || doesPointHitShape({ x: x + w, y: y + h / 2 }, shapeToHit);
    };
    const doesShapeHitOthers = (shapeToTest, shapesToHit) => {
        let isHit = false;
        for (let i = 0, l = shapesToHit.length; i < l && !isHit; i++) {
            const shapeToHit = shapesToHit[i];
            isHit = doesShapeHitShape(shapeToTest, shapeToHit);
        }
        return isHit;
    };
    let hasOverlap = false;
    let [first, ...rest] = shapes;
    while (!hasOverlap && rest.length) {
        hasOverlap = doesShapeHitOthers(first, rest);
        [first, ...rest] = rest;
    }
    const area = shapes.reduce((soFar, shape) => {
        return soFar + shape.w * shape.h;
    }, 0);
    const maxArea = (maxX - minX) * (maxY - minY);
    return { perimeter, area, maxArea, hasOverlap, outOfBounds };
}
exports.shapesMiniMax = shapesMiniMax;
